import React, { useEffect } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

function formatDate(inputDate) {
  const date = new Date(inputDate);
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  return `${date.getUTCDate()} ${months[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
}

export default function ViewStockLayer({ data }) {

  useEffect(() => {
    // Destroy previous table (prevent duplicate initialization)
    if ($.fn.DataTable.isDataTable("#logsTable")) {
      $("#logsTable").DataTable().destroy();
    }

    // Re-initialize
    $("#logsTable").DataTable({
      responsive: true,
      pageLength: 10,
      ordering: true,
    });

  }, [data]);

  return (
    <div className="card basic-data-table">
      <div className="card-body">

        {/* ==== EXISTING STOCK DETAILS UI ==== */}
        <div className="row">
          <div className="col-md-6 row">
            <div className="col-md-6 mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                Title
              </label>
              <p>{data.title}</p>
            </div>

            <div className="col-md-6 mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                Sell Price
              </label>
              <p>{data.sellPrice}</p>
            </div>

            <div className="col-md-6 mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                Cost Price
              </label>
              <p>{data.costPrice}</p>
            </div>

            <div className="col-md-6 mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                Quantity
              </label>
              <p>{data.quantity}</p>
            </div>

            <div className="col-md-6 mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                Unit
              </label>
              <p>{data?.unit?.title || data.uom || "-"}</p>
            </div>

            <div className="col-md-6 mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                Supplier
              </label>
              <p>{data?.supplier?.name}</p>
            </div>

            <div className="col-md-12 mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                Description
              </label>
              <div dangerouslySetInnerHTML={{ __html: data.description }} />
            </div>
          </div>
        </div>

        {/* ==== LOGS DATATABLE ==== */}
        <h5 className="mt-4 mb-3">Inventory Logs</h5>

        <div className="table-responsive">
          <table id="logsTable" className="table table-bordered table-striped">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Date</th>
                <th>Type</th>
                <th>Change</th>
                <th>Note</th>
                <th>Reference</th>
              </tr>
            </thead>
            <tbody>
              {data.logs?.map((log, index) => {
                const qty = Number(log.quantity_change);
                const type =
                  log.change_type ||
                  (qty < 0 ? "sell" : qty > 0 ? "add" : "adjust");

                const badgeClass =
                  qty < 0
                    ? "badge bg-danger"
                    : qty > 0
                    ? "badge bg-success"
                    : "badge bg-primary";

                return (
                  <tr key={log.id}>
                    <td>{index + 1}</td>
                    <td>{formatDate(log.createdAt)}</td>
                    <td>
                      <span className={badgeClass}>{type}</span>
                    </td>
                    <td>
                      <span className={badgeClass}>
                        {qty > 0 ? `+${qty}` : qty}
                      </span>
                    </td>
                    <td>{log.note}</td>
                    <td>{log.reference_number || "-"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}
